export const SHOW_MODAL = "modal/SHOW_MODAL";
export const HIDE_MODAL = "modal/HIDE_MODAL";
export const SET_MODAL_INFO = "modal/SET_MODAL_INFO";
